import { Time } from "@angular/common";
import { ConfirmationVia, SpecialMealDTO } from "./WidgetSettingsModels";
import { BookingGuestType } from "../constants/commonenums";

export class UpdatedPartySlotDTO {
  Id: number | null;
  Time: Date;
  IsTimeInUtc: boolean;
  Type: UpdatedPartySlotType;
  LockId: number | null;
}

export enum UpdatedPartySlotType {
  AutoSlot,
  ManualActualSlot,
  ManualDefaultSlot,
  OverbookingSlot,
  AutodetectSlot,
  NoSlot,
}

export class IdTechData {
  public track1: string;
  public track2: string;
  public track3: string;
  public track1e: string;
  public track2e: string;
  public tracke: string;
  public trackKsn: string;
  public track1len: Number
  public track2len: Number
  public encMode: string;
  public msrType: string;
  public entryMode: string;
}


export enum PartyType {
  Reservation,
  WalkIn,
  StandBy
}
export enum PageMethod {
  Manual,
  Sms,
  VoiceCall,
  Email,
  Sms2,
  VoiceCall2,
  SMSProxyRelay
}

export class UpdatedContactDTO {
  public Id?: number;
  public FirstName: string;
  public LastName: string;
  public PhoneNumber: string;
  public PhoneNumber2: string;
  public EmailAddress: string;
  public Birthday: Date;
  public Anniversary: Date;
  public IsVip: boolean;
  public IsFavorite: boolean;
  public SiteUserId: number;
  public TrackMembershipNumber: string;
  public PreferredPageMethod: PageMethod;
  public GuestProfileServiceId: string;
  public Notes: ContactNoteDTO[];
  public ContactCustomFields: CustomFieldsDTO[];
  public Photo: string;
  public ShouldUpdatePhoto: boolean;
  public PIILastUsedDate: string;
  public ConsentDate: string;
  public ConsentPolicyId: number;
  public CountryId?: number;
  public MarketingOptedIn?: boolean;
}

export class ContactNoteDTO {
  public Id: number;
  public Text: string;
  public RelatedId: number;
  public IsDietaryRestriction: boolean;
  public RestaurantId: number;
  public Icon: string;
}

export class CustomFieldsDTO {
  public Id: number;
  public ContactId: number;
  public CustomFieldId: number;
  public CustomFieldValue: string;
  public CustomFieldName: string;
}

export enum PricingStrategy
    {
        PerPerson,
        PerReservation
    }

export enum RequiredPartyFields {
  None = 0,
  PhoneNumber = 1,
  EmailAddress = 2,
  Both = 3,
  SecondaryPhoneNumber = 4,
  SecondaryEmailAddress = 5,
  SecPhoneNumberSecEmailAddress = 6,
  PhoneNumberSecPhoneNumber = 7,
  PhoneNumberSecEmailAddress = 8,
  EmailAddressSecPhoneNumber = 9,
  EmailAddressSecEmailAddress = 10,
  PhoneNumberEmailAddressSecPhoneNumber = 11,
  PhoneNumberEmailAddressSecEmailAddress = 12,
  EmailAddressSecPhoneNumberSecEmailAddress = 13,
  SecPhoneNumberSecEmailAddressPhoneNumber = 14,
  All = 15,
  Anyone = 16
}

export enum PartyNoteType {
  FreeFormNote,
  PredefinedNote,
  SpecialRequest,
  PromoCode,
  SpecialMeal
}
export class PartyNoteDTO {
  public Id: number = null;
  //public PartyId: number = null;
  public Text: string = null;
  public Type: PartyNoteType = null;
  public RelatedId: number = null;
}
export class UpdatedPartyDTO {
  Id: number;
  Type: PartyType;
  Size: number;
  SeatingAreaId: number;
  SeatingTypeId: number;
  SeatingTime: Date | null;
  PageMethod: PageMethod;
  Contact: UpdatedContactDTO;
  HostId: number;
  TableIds: number[];
  PagerNumber: string;
  Notes: PartyNoteDTO[];
  CartId: string;
}

export class CoverTypeQuantityDTO {
  public Id: number;
  public CoverTypeId: number;
  public Covers: number;
  public CoverTypeName: string;
  public Price: Number;

}
export class BookingTypeQuantityDTO {
  public Id: number;
  public BookingTypeId: number;
  public BookingTypes: number;
  public BookingTypeName: string;
  public Price: Number;

}
export class UpdatedReservationDTO extends UpdatedPartyDTO {
  public Slot: UpdatedPartySlotDTO;

  public SpecialMealId?: Number;
  public OfferId?: Number;

  public HotelId?: Number;
  public ConciergeId?: Number;

  //public  SpecialMealPaidAmount?: decimal
  public ReservationAttemptId?: Number;

  public RemindAboutVisit: boolean;
  public RemindAboutVisitEmail: boolean;
  public AgreedWithTermsOfUse: boolean;
  public ConfirmationMessageOption: ConfirmationVia;

  public OriginalRestaurantId?: Number;

  public IdTechData: IdTechData;
  public CoverTypes: CoverTypeQuantityDTO[];
}


export class RegisterReservationAttemptRequestDTO {
  public PartySize: Number;
  public LocalTime: Date;
  public SpecialMealId?: Number;
  public TableId: Number[];
  public SeatingTypeId?: Number;
  public PartyId?: Number;
  public ClientIP: string;
  public CoverTypes: CoverTypeQuantityDTO[];
  public BookingTypes: BookingTypeQuantityDTO[];
  public ForceIFrameUrl: Boolean;
}

export class NewPartyDetailsDTO {
  public PartyId: Number;
  public ContactId: Number
  public ConfirmationCode: string
  public EmailAddress: string
  public Token: string
  //public  PurchaseForm : PurchaseFormDTO
  public Shift4CardType: string
  public Shift4Invoice: string
  public Shift4CustomerReceiptText: string
  public Shift4CustomerName: string
  public Shift4Clerk: string
  public Shift4TransactionDate: string
  public Shift4Authorization: string
  public FirstName: string
  public LastName: string

}
export class ReservationInfoDTO {
  public CreditCardRequired: boolean;

  public IsDeferredPaymentMode: boolean
}

export class RegisterReservationAttemptResponseDTO {
  public IsSuccessful: boolean;
  public ReservationAttemptId: number;
  public CreditCardIFrameURL: string;
  public OperationCurrency: string;
  public PaymentAmount: Number;
  public RateplanAmountinfo: Number;
  public SpecialMealAmountinfo: Number;
  public ShouldCreditCardBeEntered: boolean;
  public PaymentTarget: PaymentTargets;
  public PaymentGateway: PaymentGateways;
  public Shift4Server: string;
  public Shift4AccessBlock: string;
  public IsShift4Restaurant: boolean;
  public UseIdTech: boolean;
  public IsImmediatePaymentMode: boolean;
  public RatePlanTotal: any;
  public Slots: any;
  public ResponseDTOs: any;
  public Taxes: any;
  public TaxAmount:number;
  public ServiceChargeAmount: number;
  public ServiceCharges: any;
  public Tax :any;
  public TaxOnServiceChargeAmount: number;
}

export enum PaymentTargets {
  None,
  SpecialMeal,
  NoShowFee,
  RatePlan,
  SpecialMealAndRatePlan,
  NoshowFeeAndRatePlan
}

export enum PaymentGateways {
  FreedomPay,
  rGuestPay,
  AuthorizePay
}

export class ReservationAttemptBasicInfo {
  public State: PaymentStates;
}

export class BookingTypeInfo {
  BookingGuestType : BookingGuestType;
  Input: string;
}

export class ReservationMultipleAttemptBasicInfo {
  public State: PaymentStates;
  public ReservationAttemptId: Number;
}

export enum PaymentStates {
  PaymentNotRequired,
  PaymentPending,
  Authorized,
  ChargeCaptured
}

export class CustomGuestFieldsModel {
  public Errors: string[];
  public IsUpdated: boolean;
  public MasterMerchantId: Number;
  public CustomGuestField: CustomGuestFieldDTO[];
}

export class CustomGuestFieldDTO {
  public Id: Number;
  public MasterMerchantId: Number;
  public FieldType: string;
  public FieldName: string;
  public FieldDescription: string;
  public IsCustomGuestFieldVisible: boolean;
  public FieldOptions: string;
  public AvailableForOnlineReservation: boolean;
}

export class AuthorizeIFrameInfoDTO {
  public formURL: string;
  public transactionId: string
  public successCode: Number;
  public errorCode: string
  public token: string;
  public Result: object;
}


export class SecondaryContactDTO {
  public Id: Number;
  public GuestProfileServiceId: string;
  public ContactId: Number;
  public FirstName: string;
  public LastName: string;
  public AliasName: string;
  public ContactNotes: string;
  public PartyId: Number;
  public PhoneNumber: string;
  public EmailAddress: string;
  public Notes: ContactNoteDTO[];
  public CountryId: Number;
  public ContactCustomFields: CustomFieldsDTO[];
  public isValid?: boolean = false;
  public count?: number;
  public IsSystemGenerated?: boolean = false;
}

export enum PartyState {
  Pending,
  Seated,
  Left,
  NoShowed,
  Cancelled,
}
export enum PartyStateUpdateSource {
  TableSaver,
  CleanUpScript
}

export class ContactDTO {
  public Id: number = null;
  public FirstName: string = null;
  public LastName: string = null;
  public AliasName?: string = null;
  public IsVip: boolean = null;
  public IsFavorite: boolean = null;
  public PhoneNumber: string = null;
  public PhoneNumber2: string = null;
  public EmailAddress: string = null;
  public SiteUserId: number = null;
  public GuestScore: number = null;
  public CreatedAt: Date = null;
  public Notes: ContactNoteDTO[] = [];
  public CustomGuestField: CustomGuestFieldDTO[] = [];
  public ContactCustomFields: CustomFieldsDTO[] = [];
  public PIILastUsedDate: Date = null;
  public ConsentDate: Date = null;
  public ConsentPolicyId: number = null;
  public CountryId: number = null;
  public MarketingOptedIn?: boolean;
}

export class FullContactDTO extends ContactDTO {
  public Options: GetContactOptions = null;
  public PreferredPageMethod: PageMethod = null;
  public SecondaryContactsList: SecondaryContactDTO[] = [];
  public Birthday: Date = null;
  public Anniversary: Date = null;
  public VisitStats: ContactVisitStatsDTO[] = [];
  public FutureReservations: ReservationDTO[] = [];
  public PastReservations: ReservationDTO[] = [];
  public Walkins: WalkInDTO[] = [];
  public BillingPreferences: string = null;
  public PreferredTableId: number = null;
  public PreferredServerId: number = null;
  public PartnerName: string = null;
  public PartnerBirthday: Date = null;
  public TrackMembershipNumber: string = null;
  public Addresses: ContactAddressDTO[] = [];
  public Photo: string = null;
  public ShouldUpdatePhoto: boolean = false;
  public MemberInformation : any = null;
}
export class FilterDTO {
  public MembershipId: string = null;
  public InProgress: number = null;
  public LocationId: number = null;
  public InstructorId: string = null;
  public StartDate: Date = null;
  public EndDate: Date = null;
  public StartTime: Time = null;
  public EndTime: Time = null;
  public filteredDays = [];
}

export enum GetContactOptions {
  None = 0,
  BasicContact = 1,
  ExtendedContactFields = 2,
  Notes = 4,
  Photo = 7,
  VisitStatsForCurrentRestaurant = 8,
  VisitStatsForOtherRestaurants = 16,
  Addresses = 32,
  PredefinedNotesText = 64,
  FutureReservations = 128,
  ReservationsAcrossAllRestaurants = 256,
  CreditCardsForFutureReservations = 512,
  BasicContactWithNotes = BasicContact | Notes,
  FullContact = BasicContact | ExtendedContactFields | Notes | Addresses,
  FullContactWithPhoto = BasicContact | ExtendedContactFields | Notes | Addresses | Photo,
  FullWithStats = FullContact | VisitStatsForCurrentRestaurant | VisitStatsForOtherRestaurants,
  FullWithStatsAndPredefinedNotes = FullWithStats | PredefinedNotesText | FutureReservations | ReservationsAcrossAllRestaurants,
  FullWithStatsAndPredefinedNotesIncludeCreditCards = FullWithStats | PredefinedNotesText | FutureReservations | ReservationsAcrossAllRestaurants | CreditCardsForFutureReservations,
  FullWithStatsAndPredefinedNotesIncludeCreditCardsAndPhoto = FullWithStats | PredefinedNotesText | FutureReservations | ReservationsAcrossAllRestaurants | CreditCardsForFutureReservations | Photo,
  ContactCustomFields = 3,
  CustomGuestFields = 5,
  BasicContactWithNotesAndCustomFields = BasicContact | Notes | ContactCustomFields | CustomGuestFields
}

export class ContactVisitStatsDTO {
  public RestaurantId: number;
  public RestaurantName: string;
  public ContactId: number;
  public LastVisitedAt: Date;
  public NumberOfVisits: number;
  public NumberOfVisitsLast30Days: number;
  public NumberOfCancellations: number;
  public NumberOfCancellationsLast30Days: number;
  public NumberOfNoShows: number;
  public NumberOfNoShowsLast30Days: number;
  public LastServerName: string;
  public LastTableNames: string;
  public TotalSpend: number;
  public AverageSpend: number;
  public NumberOfWalkins: number;
  public NumberOfVisitsAsReservation: number;
}

export class ContactAddressDTO {
  public Id: number;
  public Name: string;
  public Street1: string;
  public Street2: string;
  public City: string;
  public Country: string;
  public State: string;
  public PostalCode: string;
}

export class PartyDTO {
  public Id: number;
  public RestaurantId: number;
  public Type: PartyType;
  public State: PartyState;
  public StateUpdateSource: PartyStateUpdateSource;
  public Size: number;
  public SeatingAreaId: number;
  public TableIds: number[];
  public TableNames: string[];
  public SeatingTime: Date;
  public DepartureTime: Date;
  public NoShowedAt: Date;
  public CancelledAt: Date;
  public CreatedAt: Date;
  public UpdatedAt: Date;
  public HostId: number;
  public StatusId: number;
  public PartySourceId: number;
  public CancelationSourceId: number;
  public ConfirmationCode: string;
  public IsConfirmed: boolean;
  public IsVipPartyServed: boolean;
  public PagerNumber: string;
  public PageMethod: PageMethod;
  public LastPagedAt: Date;
  public ReservedFor: Date;
  public Contact: ContactDTO;
  public Notes: PartyNoteDTO[];
  public Messages: PartyMessageDTO[];
  public CheckSum: number;
  public NumberOfChecks: number;
  public GuestScore: string;
  public ActivityId: string;
  public GuestProfileId: string;
  public Covers: CoverTypeQuantityDTO[];
  public SpecialMealId: number;
  public SpecialMeal: SpecialMealDTO;
  public ChargeState: PartyChargeState;
  public SeatingTypeId: number;
  public WaiverFormTransactionId: string;
  public BookingContacts: SecondaryContactDTO[];
  public CoverTypeQuantities: CoverTypeQuantityDTO[];
  public BookingTypeQuantities: BookingTypeQuantityDTO[];
  public StaffId: any[];
  public StartDate: Date;
  public EndDate: Date;
}

export class ReservationDTO extends PartyDTO {
  public ReservationDate: Date = null;
  public ReservedFor: Date = null;
  public SlotId: number = null;
  public SpecialMealId: number = null;
  public HotelId: number = null;
  public ConciergeId: number = null;
  public Token: string = null;
  public IsCommunalTable: boolean = null;
  public IsCCAssociated: boolean = null;
  public NoShowFeeAmount: number = null;
  public ChargedAt: Date = null;
  public RefundedAt: Date = null;
  public AutomaticallyRefundedAt: Date = null;
  public ChargeState: PartyChargeState = null;
  public PrepaymentState: PartyPrepaymentState = null;
  public ChargeHostName: string = null;
  public RefundHostName: string = null;
  public RefundCRSUserName: string = null;
  public CreditCardId: number = null;
  public MaskedCardNumber: string = null;
  public SpecialMealAmount: number = null;
  public OperationCurrency: string = null;
  public RemindAboutVisit: boolean = null;
  public RemindAboutVisitEmail: boolean = null;
  public TooLateToCancel: boolean = null;
  public CoverTypeQuantities: CoverTypeQuantityDTO[] = [];
  public BookingTypeQuantities: BookingTypeQuantityDTO[] = [];
  public SpecialMealName: string = null;
  public OverpaymentAmount: number = null;
  public SpecialMeal: SpecialMealDTO = null;
  public RatePlanAmount: number = null;
  public CheckIconVisibility: boolean = null;
  public GuestReservationEmail: GuestReservationEmail;
  public GuestReservationPhoneNumber: GuestReservationPhoneNumber;
  public CancellationFeeAmount: number = null;
  public UniqueId: string = null;
  public MerchantId: string = null;
  public CartBookingId: string = null;
  public BookingReferenceId: string = null;
  public TaxAmount?: number = null;
  public TotalServiceChargeAmount?: number = null;
  public TaxOnServiceChargeAmount?: number = null;
}

export enum GuestReservationEmail {
  Email,
  Email2
}

export enum GuestReservationPhoneNumber {
  PhoneNumber,
  PhoneNumber2
}

export enum PartyPrepaymentState {
  None,
  PrepaymentRequired,
  PrepaymentInProgress,
  Prepaid,
  PrepaymentFailed,
  Refunded,
  RefundFailed,
  PartialPrepayment,
  DeferredPayment,
  DepositCollected
}
export enum PartyChargeState {
  None,
  Pending,
  InProgress,
  Charged,
  ChargeFailed,
  Ignored,
  Refunded,
  RefundFailed
}

export enum PaymentMethod
{
    None = 0,
    Prepayment = 1,
    PartialPayment = 2,
    Authorize = 3,
    SkipPayment = 4
}

export enum PaymentMode
{
    None,
    PrepaidPaymentMode,
    DefferredPaymentMode,
    DepositPaymentMode,
    ChargeduringCheckIn,
    ChargeduringCheckOut,
    CardOnFile
}

export class PartyMessageDTO {
  public Id: number = null;
  //public PartyId: number = null;
  public CreatedAt: Date = null;
  public Text: string = null;
  public IsIncoming: boolean = null;
  public IsPostVisitSMS: boolean = null;
}

export class FinancialEffectForUpdatedReservationDTO {
  public PartyPaymentType: FinancialEffectType;
  public PaymentTarget: PaymentTargets;
  public PaymentAmount?: number;
  public SpecialMealAmount?: Number;
  public RatePlanAmount?: Number
  public TotalAmount?: number
  public FinancialEffects: FinancialEffectForUpdatedReservationDTO[]
  public IsCreditCardNeeded: boolean;
  public RedirectUrl: string;
  public ReservationAttemptId: number;
  public PaymentGateway: PaymentGateways;
  public RefundOption: any;
  public RatePlanTotal: any;
  public ServiceChargeAmount: any;
  public TaxAmount: any;
  public TaxOnServiceCharge: any;
  public RetailCreditCardPaymentTokenId: number;
  public CardNumber: string;
}

export enum FinancialEffectType {
  NotSupported,
  NoPaymentsInvolved,
  NoEffect,
  NewReservationAttempt,
  NoFullRefund,
  FullRefund,
  NoFullRefundAndNewReservationAttempt,
  FullRefundAndNewReservationAttempt,
  PartialCharge,
  PartialRefund,
  NoShowFeeUpdated,
  Authorize,
  AuthorizeUpdated,
  ChargeCancellationLater,
  FullRefundAndNoShowFee
}

export enum SessionAvailabiltyStatus {
  Available,
  LimitedAvailability,
  LessAvailability,
  NotAvailable,
  PastTime,
  Blocked
}

export class WalkInDTO extends PartyDTO {
  public ArrivedAt: Date;
  public QuotedSeatingTime: Date;
  public IsSeatingTimeOverriden: boolean;
  public Position: number;
  public CheckIconVisibility: boolean = null;
}
